import { Injectable } from '@angular/core';
import { Command } from '../command/command';
import { CommandHandler } from '../command/command-handler';
import { State } from '../state';
import { AppState } from '../state.module';

import {
  AddCurrentShipmentWizzardStep,
  AddReceiverTypeCommand,
  AddReceiverCommand,
  AddSenderCommand,
  AddSelectedOrderCommand,
  AddShipmentIdCommand
} from './shipment-commands';

@Injectable()
export class ShipmentCommandHandlerService implements CommandHandler {

  handle(state: State, command: Command): State {
    const appState = (state as AppState);

    switch (command.name) {
      case 'add_current_shipment_wizzard_step':
        const addCurrentShipmentWizzardStep = (command as AddCurrentShipmentWizzardStep);
        return appState.shipment.addCurrentShipmentWizzardStep(addCurrentShipmentWizzardStep.step);

      case 'add_receiver_type':
        const addReceiverTypeCommand = (command as AddReceiverTypeCommand);
        return appState.shipment.addReceiverType(addReceiverTypeCommand.receiverType);

      case 'add_receiver':
        const addReceiverCommand = (command as AddReceiverCommand);
        return appState.shipment.addReceiver(addReceiverCommand.receiver);

      case 'add_sender':
        const addSenderCommand = (command as AddSenderCommand);
        return appState.shipment.addSender(addSenderCommand.sender);

      case 'add_selected_order':
        const addSelectedOrderCommand = (command as AddSelectedOrderCommand);
        return appState.shipment.addSelectedOrder(addSelectedOrderCommand.selectedOrder);

      case 'add_shipment_id':
        const AddShipmentIdCommand = (command as AddShipmentIdCommand);
        return appState.shipment.addShipmentId(AddShipmentIdCommand.id);

    }

    throw new Error(`OrderCommandHandlerService cannot handle command ${command.name}".`);
  }
}



// WEBPACK FOOTER //
// ./src/app/state/shipment/shipment-command-handler.service.ts